module.exports = __webpack_public_path__ + "img/indoor1.59c2d745.jpg";